import React, { Component } from "react"
import PropTypes from "prop-types"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
import { Table } from "elemental-react16"
import { Button } from "semantic-ui-react"
import ProductCount from "components/Product/ProductCount"
import Price from "components/Price/Price"
import _ from "lodash"
import LabelSale from "components/Product/LabelSale"
import shop from "shop/shop"

@observer
export default class ProductTable extends Component {
  static propTypes = {
    list    : PropTypes.object,
    cart    : PropTypes.object,
    onChange: PropTypes.func,
    products: PropTypes.array,
  }

  render() {
    const { products } = shop.cart
    let { list, cart, onChange, lastCol } = this.props
    let positions = list || products
    const ProductRow = this.props.row || ProductRowDefault
    if ( list ) positions = list.products
    let rows = _.map( positions, ( product, index ) => {
      return (
        <ProductRow key={index} index={index} onChange={onChange} list={list} cart={cart} product={product}/>
      )
    } )
    return (
      <Table>
        <colgroup>
          <col width="30"/>
          <col width=""/>
          <col width="10%"/>
          <col width="10%"/>
          <col width="10%"/>
          <col width="10%"/>
          <col width="10%"/>
          {lastCol && <col width="10%"/>}
        </colgroup>
        <thead>
        <tr>
          <th>&nbsp;</th>
          <th>{translate( "article" )}</th>
          <th>{translate( "deliverable" )}</th>
          <th>{translate( "Preis" )}</th>
          <th>{translate( "Summe" )}</th>
          {/*<th>{translate("Preis/VE")}</th>*/}
          {/*<th>{translate( "total count" )}</th>*/}
          <th>{translate( "piece" )}</th>
          {lastCol && <th>{translate( lastCol )}</th>}

          {/*<th>{translate( "VE" )}</th>*/}
          {/*<th style={{ textAlign: "right" }}>{translate( "amount (VE)" )}</th>*/}
          {list && <th style={{ textAlign: "right" }}>{translate( "" )}</th>}
        </tr>
        </thead>
        <tbody>
        {rows}
        </tbody>
      </Table>
    )
  }
}

const ProductRowDefault = ( { product, onChange, list, cart, index } ) => {
  return (
    <tr>
      <td>
        {cart ? <CartActions cart={cart} product={product}/> : null}
      </td>
      <td>
        <div>
          <div className="fl pr2 w-100 mw3">
            <Link to={`/product/${product.map_id}`}>
              <img
                className="db center"
                height="34"
                src={product.img_src_small}
                alt=""/>
            </Link>
          </div>
          <Link to={`/product/${product.map_id}`}>
            <div className={"b"}>{product.article_nr}</div>
            <div className="product-title">{product.desc.des}</div>
            {/*<span className="unit_multi black-50">VE {product.unit_multi} {translate( "cart.piece" )}</span>*/}
          </Link>
        </div>
      </td>
      <td><span className="f6">{product.getNotice( "tiny" )}</span></td>
      <td>
        <div><Price currency={shop.session.value.currency ? shop.session.value.currency : '€'}>{product.price * product.unit_multi}</Price></div>
        {product.isSale && <div><LabelSale price={product.originalPrice} percent={product.salePercent}/></div>}
      </td>
      <td className="tr">
        <div><Price currency={shop.session.value.currency ? shop.session.value.currency : '€'}>{product.price * product.count * product.unit_multi}</Price></div>
        {product.isSale && <div><LabelSale price={product.originalPrice * product.count * product.unit_multi}
                                           percent={product.salePercent}/></div>}
      </td>
      {/*<td><DropdownQuantities product={product} onChange={onChange}/></td>*/}
      <td className="tr">
        <ProductCount product={product} onChange={onChange}/>
      </td>
      {list && <td>
        <div className="fr"><ListActions list={list} product={product}/></div>
      </td>}
    </tr>
  )
}

ProductRowDefault.propTypes = {
  index   : PropTypes.any,
  list    : PropTypes.object,
  cart    : PropTypes.object,
  onChange: PropTypes.func,
  product : PropTypes.any,
}

const CartActions = ( { cart, product } ) => {
  return (
    <Button
      onClick={() => {
        cart.remove( product )
      }}
      basic
      icon="cancel"
      size="tiny"
    />
  )
}

CartActions.propTypes = {
  cart   : PropTypes.object,
  product: PropTypes.object,
}

const ListActions = ( { list, product } ) => {
  return (
    <Button.Group className="pl2">
      <Button
        icon="trash"
        onClick={() => {
          list.remove( product )
        }}
      />
      <Button
        icon="cart"
        onClick={() => {
          list.toCart( product )
        }}
      />
    </Button.Group>
  )
}

ListActions.propTypes = {
  list   : PropTypes.object,
  product: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/components/Product/ProductTable.js